import _ from "lodash";
import React, { useState, useEffect, useRef } from "react";
import "../producto.css";
import "../producto-seccionado.css";
import { icons } from "icons";
import { connect } from "react-redux";
import LoadMask from "Utils/LoadMask/LoadMask";
import { CAPACIDAD, PESO, LONGITUD } from "utility/variables";
import FraccionesComponent from "../Fraccion/FraccionContainer";
import FileUploader from "../../Utils/FileUploader/FileUploader";
import Select from "react-select";
import { change } from "redux-form";
import TipoProductoTab from "./TipoProductoTab";
import Swal from "sweetalert2";

import { Field, reduxForm, formValueSelector, FieldArray } from "redux-form";
import {
    renderField,
    renderTextArea,
    renderNumber,
    renderCurrency,
    renderPorcentaje,
    renderSearchSelect,
} from "../../Utils/renderField/renderField";
import { RenderCurrency as RCurrency } from "Utils/renderField/renderReadField";
import Catalogo from "./Catalogo";
import TreeCategoria from "../TreeCategoria";
import { preciosSucursal } from "../camposProducto";

import SettingToggle from "../../../components/Utils/Ayuda/SettingToggle";
import ModalCarrusel from "../../Utils/Ayuda/ModalCarrusel";

//S3 imagenes de ayuda 
import confnegativo from 'assets/img/Bienvenida.png';
import FraccionesListado from "../../../components/Producto/Fraccion/Fracciones";

import PrecioSucursalSection from "../Secciones/PrecioSucursalSection";
import PropiedadesProductoSection from "../Secciones/PropiedadesProductoSection";
import InventarioInicialSection from "../Secciones/InventarioInicialSection";


// VALIDACIONES CUSTOMS
const validate = (values) => {
    const errors = {};
    if (!values.nombre) errors.nombre = "Campo requerido";
    if (values.peso < 0) errors.peso = "No puede ser negativo";
    if (!values.descripcion) errors.descripcion = "Campo requerido";

    if (values.tipo_producto != "100") {
        if (!values.precio && values.precio != "0")
            errors.precio = "Campo requerido";
        if (values.descripcion_codigo_barras) {
            if (values.descripcion_codigo_barras.length > 20)
                errors.descripcion_codigo_barras = "Debe tener 20 caracteres o menos.";
        }
    } else {
        values.precio = null;
        values.precio2 = null;
        values.precio3 = null;
        values.precio4 = null;
        values.precio5 = null;
        values.codigos_barras = null;
        values.descripcion_codigo_barras = null;
    }
    
    if (!values.inventariable) {
        values.alertar = false;
        values.minimo_existencias = null;
        values.tiene_fracciones = false;
    }
    
    if (values.alertar) {
        if (!values.minimo_existencias)
            errors.minimo_existencias = "Campo requerido";
    } else {
        values.minimo_existencias = null;
    }

    if (values.tienda_online) {
        if (!values.precio_online) {
            errors.precio_online = "Campo requerido";
        }
    }
    
    if (values.precios_sucursal) {
        if (values.precios_sucursal.length) {
            const preciosSucursalArrayErrors = [];
            values.precios_sucursal.forEach((precio_sucursal, index) => {
                const precioSucursalErrors = {};
                if (!precio_sucursal["precio"] && precio_sucursal["precio"] != "0")
                    precioSucursalErrors.precio = "Campo requerido";
                preciosSucursalArrayErrors[index] = precioSucursalErrors;
            });
            if (preciosSucursalArrayErrors.length)
                errors.precios_sucursal = preciosSucursalArrayErrors;
        }
    }

    if (values.codigos_barras && values.codigos_barras.length > 0) {
        const codigosBarrasArrayErrors = [];
        const codigosVistos = new Set();
        
        values.codigos_barras.forEach((name, index) => {
            const codigoErrors = {};
            if (name.codigo) {
                const codigo = name.codigo.trim();
                if (!/^\w+$/i.test(codigo)) {
                    codigoErrors.codigo = "Debe contener solo letras y/o números.";
                    codigosBarrasArrayErrors[index] = codigoErrors;
                } else if (codigosVistos.has(codigo)) {
                    codigoErrors.codigo = "Este código ya existe en la lista. No se permiten duplicados.";
                    codigosBarrasArrayErrors[index] = codigoErrors;
                } else {
                    codigosVistos.add(codigo);
                }
            }
        });
        
        if (codigosBarrasArrayErrors.length) {
            errors.codigos_barras = codigosBarrasArrayErrors;
        }
    }

    return errors;
};

const renderCodigosBarras = ({ fields }) => {
    React.useEffect(() => {
        if (fields.length === 0) {
            fields.push('');
        }
    }, [fields]);

    return (
        <div>
            {fields.map((name, index) => (
                <div key={index} className="form-group d-flex align-items-center">
                    <Field
                        name={`${name}.codigo`}
                        component={renderField}
                        type="text"
                        className="form-control me-2"
                        placeholder="Ingrese código de barras"
                    />
                    {index === 0 ? (
                        <button
                            type="button"
                            className="btn d-flex btn-no-shadow justify-content-center align-items-center"
                            onClick={() => fields.push("")}
                        >
                            <img
                                src={require("../../../../../assets/img/icons/agregar.png")}
                                alt="Agregar"
                            />
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="btn btn-no-shadow justify-content-center align-items-center"
                            onClick={() => fields.remove(index)}
                        >
                            <img
                                src={require("../../../../../assets/img/icons/eliminar.png")}
                                alt="Eliminar"
                            />
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
};


//S1
const SECTIONS_BY_TIPO = {
    simple: [
        "datos-generales",
        "inventario-inicial",
        "manejo-producto",
        "precios-generales",
        "precio-sucursal",
        "propiedades-producto",
        "resumen"
    ],
    medida: [
        "datos-generales",
        "inventario-inicial",
        "propiedades-producto",
        "manejo-producto",
        "precios-generales",
        "precio-sucursal",
        "resumen"
    ],
    fraccionado: [
        "datos-generales",
        "propiedades-producto",
        "manejo-producto",
        "resumen"
    ],
};

//S1
const ALL_SECTIONS = [
    { id: "datos-generales", label: "Datos Generales", icon: "✓" },
    { id: "inventario-inicial", label: "Inventario Inicial", icon: "○" },
    { id: "precios-generales", label: "Precios Generales", icon: "✓" },
    { id: "precio-sucursal", label: "Precio Sucursal", icon: "✓" },
    { id: "propiedades-producto", label: "Propiedades de producto", icon: "✓" },
    { id: "manejo-producto", label: "Manejo de producto", icon: "○" },
    { id: "resumen", label: "Resumen Final" }
];

const Form = (props) => {
    const [selectedSection, setSelectedSection] = useState("datos-generales");

    //S1
    const [tipoProducto, setTipoProducto] = useState("simple");
    
    console.log('Form renderizado con selectedSection:', selectedSection);
    
    // Monitorear cambios en selectedSection
    useEffect(() => {
        console.log('selectedSection cambió a:', selectedSection);
    }, [selectedSection]);
    
    const {
        unidades_de_medida_empresa,
        tipoProductoValue,
        fraccionadoValue,
        inventariableValue,
        alertaValue,
        unidadDeMedidaValue,
        seleccion_unidades_medida,
        foto_producto,
        conf_tienda_online,
        tienda_onlineValue,
        deBodega,
        loader,
        categorias,
        categorias_seleccionados,
        categoriaSelect,
        categorias_expanded,
        sucursales,
        sucursal,
        sucursal_activo,
        nombres_precios,
        conf_porcentaje_precio,
        conf_tipo_negocio,
        familias,
        getFamilias,
        precio2Value,
        precio3Value,
        precio4Value,
        precio5Value,
        precios_sucursalValue,
        kilataje,
        empresa,
        handleSubmit,
        crearProducto,
        onFileChange,
        cambioSeleccionUnidad,
        cambioTipoProducto,
        regresar,
        asignarCategoria,
        setCategoriasExpanded,
        changeSucursal,
        changeSucursalActivo,
        cambioPorcentajePrecio,
    } = props;
    

    // Unidades de medida por el tipo
    let unidades_medida = [];
    if (tipoProductoValue == "1000") {
        unidades_medida = _.filter(unidades_de_medida_empresa, function (unidad) {
            return unidad.tipo == PESO;
        });
    } else if (tipoProductoValue == "2000") {
        unidades_medida = _.filter(unidades_de_medida_empresa, function (unidad) {
            return unidad.tipo == CAPACIDAD;
        });
    } else if (tipoProductoValue == "3000") {
        unidades_medida = _.filter(unidades_de_medida_empresa, function (unidad) {
            
            return unidad.tipo == LONGITUD;
        });
    }
    unidades_medida = _.orderBy(unidades_medida, ["capacidad"], ["asc"]);

    const kilatajes = [
        {
            label: "9.25k",
            value: 9.25,
        },
        {
            label: "10k",
            value: 10,
        },
        {
            label: "14k",
            value: 14,
        },
        {
            label: "18k",
            value: 18,
        },
        {
            label: "21k",
            value: 21,
        },
        {
            label: "24k",
            value: 24,
        },
    ];

    useEffect(function () {

        if (
            tipoProducto === "medida" &&
            inventariableValue &&
            tienda_onlineValue &&
            unidades_medida &&
            unidades_medida.length > 0 &&
            !unidadDeMedidaValue
        ) {
            console.log("Inicializando unidad de medida automáticamente:", unidades_medida[0].id);

            props.change("unidad_de_medida", unidades_medida[0].id);
        }

    }, [
        tipoProducto,
        inventariableValue,
        tienda_onlineValue,
        unidades_medida,
        unidadDeMedidaValue
    ]);

    const tiendaOnlinePrevValue = useRef(null);

    useEffect(() => {
        const esMedida = tipoProducto === "medida";

        if (esMedida) {
            // Guardar valor anterior solo una vez
            if (tiendaOnlinePrevValue.current === null) {
                tiendaOnlinePrevValue.current = tienda_onlineValue;
            }

            // Forzar a false si estaba activo
            if (tienda_onlineValue) {
                props.change("tienda_online", false);
            }

        } else {
            // Si vuelve a simple o fraccionado
            if (tiendaOnlinePrevValue.current !== null) {
                props.change("tienda_online", tiendaOnlinePrevValue.current);
                tiendaOnlinePrevValue.current = null;
            }
        }

    }, [tipoProducto]);

    //S1
    const sections = ALL_SECTIONS
    .filter(section =>
        SECTIONS_BY_TIPO[tipoProducto].includes(section.id)
    )
    .map(section => {
        if (section.id === "manejo-producto") {

            let label = "Manejo de producto";

            if (tipoProducto === "simple") {
                label = "Manejo de producto simple";
            }

            if (tipoProducto === "medida") {
                label = "Manejo de producto con medida";
            }

            if (tipoProducto === "fraccionado") {
                label = "Manejo de producto fraccionado";
            }

            return { ...section, label };
        }

        return section;
    });

    // Función para obtener el icono de la sección basado en el progreso
    const getSectionIcon = (sectionId) => {
        const currentIndex = sections.findIndex(section => section.id === selectedSection);
        const sectionIndex = sections.findIndex(section => section.id === sectionId);
        
        if (sectionIndex < currentIndex) {
            return "✓"; // Completado
        } else if (sectionIndex === currentIndex) {
            return "●"; // Actual
        } else {
            return "○"; // Pendiente
        }
    };

    // Funciones de navegación
    const goToNextSection = () => {
        console.log('Intentando ir a la siguiente sección');
        const currentIndex = sections.findIndex(section => section.id === selectedSection);
        console.log('Sección actual:', selectedSection, 'Índice:', currentIndex);
        if (currentIndex < sections.length - 1) {
            const nextSection = sections[currentIndex + 1].id;
            console.log('Yendo a la siguiente sección:', nextSection);
            setSelectedSection(nextSection);
        } else {
            console.log('Ya estás en la última sección');
        }
    };

    const goToPreviousSection = () => {
        console.log('Intentando ir a la sección anterior');
        const currentIndex = sections.findIndex(section => section.id === selectedSection);
        console.log('Sección actual:', selectedSection, 'Índice:', currentIndex);
        if (currentIndex > 0) {
            const previousSection = sections[currentIndex - 1].id;
            console.log('Yendo a la sección anterior:', previousSection);
            setSelectedSection(previousSection);
        } else {
            console.log('Ya estás en la primera sección');
        }
    };

    // Verificar si se puede ir a la siguiente sección
    const canGoNext = () => {
        const currentIndex = sections.findIndex(section => section.id === selectedSection);
        return currentIndex < sections.length - 1;
    };

    // Verificar si se puede ir a la sección anterior
    const canGoPrevious = () => {
        const currentIndex = sections.findIndex(section => section.id === selectedSection);
        return currentIndex > 0;
    };

    //S1
        const onChangeTipoProducto = (tipo) => {
        setTipoProducto(tipo);
        setSelectedSection(SECTIONS_BY_TIPO[tipo][0]);

        // SINCRONIZAR CON redux-form
        if (tipo === "fraccionado") {
            props.change("tipo_producto", "100");
        } else if (tipo === "medida") {
            props.change("tipo_producto", "1000"); // o el que corresponda
        } else {
            props.change("tipo_producto", "1"); // simple
        }
    };


    
    //S2
    const hasPreciosSucursal =
        Array.isArray(precios_sucursalValue) &&
        precios_sucursalValue.length > 0;

    //S3
    // Estados para el modal
    const [showModal, setShowModal] = useState(false);
    const [modalImages, setModalImages] = useState([]);
    
    // Función para abrir modal
    const openModal = (images) => {
        setModalImages(images);
        setShowModal(true);
        };
        
        // Función para cerrar modal
        const closeModal = () => {
        setShowModal(false);
        setModalImages([]);
    };    

    //Metodo para ir a una seccion en especifico
    const goToSection = (sectionId) => {
        setSelectedSection(sectionId);
    };


    const renderSectionContent = () => {
        switch (selectedSection) {
            case "datos-generales":
                return <DatosGeneralesSection 
                    {...props}
                    change={props.change} 
                    kilatajes = {kilatajes}
                    kilataje = {kilataje}
                    tipoProducto={tipoProducto}
                    onNext={goToNextSection} 
                    onPrevious={goToPreviousSection} 
                    canGoNext={canGoNext()} 
                    canGoPrevious={canGoPrevious()} 
                />;
            case "inventario-inicial":
                return (
                    <InventarioInicialSection
                        {...props}
                        sucursales={sucursales}
                        onNext={goToNextSection}
                        onPrevious={goToPreviousSection}
                        canGoNext={canGoNext()}
                        canGoPrevious={canGoPrevious()}
                    />
                );
            case "precios-generales":
                return <PreciosGeneralesSection 
                    {...props} 
                    onNext={goToNextSection} 
                    onPrevious={goToPreviousSection} 
                    canGoNext={canGoNext()} 
                    canGoPrevious={canGoPrevious()} 
                />;
            case "precio-sucursal":
                return <PrecioSucursalSection 
                {...props} 
                onNext={goToNextSection} 
                onPrevious={goToPreviousSection} 
                canGoNext={canGoNext()} 
                canGoPrevious={canGoPrevious()}
                />;
            case "propiedades-producto":
                return <PropiedadesProductoSection 
                    {...props} 
                    onNext={goToNextSection} 
                    onPrevious={goToPreviousSection} 
                    canGoNext={canGoNext()} 
                    canGoPrevious={canGoPrevious()} 
                    onOpenModal={openModal}
                />;
            case "manejo-producto":
                return <ManejoProductoSection 
                    {...props} 
                    tipoProducto={tipoProducto}
                    onNext={goToNextSection} 
                    onPrevious={goToPreviousSection} 
                    canGoNext={canGoNext()} 
                    canGoPrevious={canGoPrevious()} 
                    unidades_medida={unidades_medida}

                />;
            case "resumen":
                return (
                    <ResumenSection 
                        {...props}
                        change={props.change}
                        kilatajes={kilatajes}
                        kilataje={kilataje}
                        conf_tipo_negocio={conf_tipo_negocio} 
                        tipoProducto={tipoProducto}
                        values={props.values} 
                        onPrevious={goToPreviousSection} 
                        canGoPrevious={canGoPrevious()} 
                        unidades_medida={unidades_medida}
                        sucursales={sucursales}

                        goToSection={goToSection}

                        hasPreciosSucursal = {hasPreciosSucursal}
                        sucursal = {sucursal}
                        changeSucursal = {changeSucursal} 
                        sucursal_activo = {sucursal_activo}
                        nombres_precios = {nombres_precios}
                        changeSucursalActivo = {changeSucursalActivo} 
                        conf_porcentaje_precio = {conf_porcentaje_precio}
                        cambioPorcentajePrecio = {cambioPorcentajePrecio} 
                        precios_sucursalValue = {precios_sucursalValue}
                        
                        onNext={handleSubmit(function(formValues) {
                            crearProducto();
                        })}
                    />
                );
            default:
                return <DatosGeneralesSection 
                    {...props} 
                    onNext={goToNextSection} 
                    onPrevious={goToPreviousSection} 
                    canGoNext={canGoNext()} 
                    canGoPrevious={canGoPrevious()} 
                />;
        }
    };

    return (
        <div className="grid-container mt0">
            <LoadMask loading={loader} dark blur>
                    <TipoProductoTab
                        value={tipoProducto}
                        onChange={onChangeTipoProducto}
                    />
                <div className="grid-cuerpo padding-15 p-sm-0 pt-sm-1 pb-sm-1 mt">
                    <form>
                        <div className="row">
                            {/* Navegación lateral izquierda */}
                            <div className="col-md-3">
                                <div className="section-navigation">
                                    <h5 className="mb-3">Creación de producto</h5>
                                    {sections.map((section, index) => (
                                        <div
                                            key={section.id}
                                            className={`section-item ${selectedSection === section.id ? 'active' : ''}`}
                                            onClick={() => setSelectedSection(section.id)}
                                        >
                                            <div className="section-icon">
                                                {getSectionIcon(section.id)}
                                            </div>
                                            <div className="section-label">
                                                {section.label}
                                            </div>
                                            {index < sections.length - 1 && <div className="section-connector" />}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            
                            {/* Contenido de la sección seleccionada */}
                            <div className="col-md-9">
                                <div className="section-content">
                                    {renderSectionContent()}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </LoadMask>
        </div>
    );
};

// Componentes de sección
const DatosGeneralesSection = ({readOnlyMode = false, change, kilatajes, kilataje, conf_tipo_negocio, tipoProducto, onNext, onPrevious, canGoNext, canGoPrevious, onFileChange, foto_producto, conf_tienda_online, getFamilias, producto, ...rest }) => {
    
    const productoBase = producto || {};

    const imagenAMostrar = foto_producto 
        ? (typeof foto_producto === 'string' ? foto_producto : URL.createObjectURL(foto_producto))
        : (productoBase.imagen ? productoBase.imagen : null);

    const tiene_imagen = imagenAMostrar ? true : false;

    const catalogoVirtual = { ...productoBase };

    Object.keys(rest).forEach(function(key) {
        if (key.startsWith("catalogo_") && rest[key]) {
            const index = key.split("_")[1];
            const numeroImagen = parseInt(index) + 1;
            const data = rest[key];
            catalogoVirtual["imagen_" + numeroImagen] = (data instanceof File) 
                ? URL.createObjectURL(data) 
                : data;
        }
    });


    return (
        <div className="section-panel">
            <div className="section-header">
                <h4>Datos Generales</h4>
                {!readOnlyMode && (
                    <div className="section-actions">
                        <button 
                            type="button" 
                            className="btn btn-secondary"
                            onClick={onPrevious}
                            disabled={!canGoPrevious}
                        >
                            Regresar
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-primary"
                            onClick={onNext}
                            disabled={!canGoNext}
                        >
                            Siguiente
                        </button>
                    </div>
                )}
            </div>
            
            <div className={readOnlyMode ? "read-only-wrapper" : ""}>
            <div className="row">
                <div className="col-sm-6 content-drop-zone">
                    <div className="row">
                        <div className="col-12">
                            <FileUploader
                                onFileChange={onFileChange}
                                icono={"add-img"}
                                frase={"producto."}
                                clave={"foto_producto"}
                                width="100%"
                                source={imagenAMostrar} 
                                archivo={foto_producto}
                            />
                        </div>
                        <div className="col-12">
                            <div className="mb-2 my-2 text-center">
                                Fotos adicionales
                            </div>
                            <Catalogo
                                key={"cat-" + (productoBase.id || 'nuevo')}
                                disabled={tiene_imagen ? "" : true}
                                onFileChange={onFileChange}
                                catalogo={catalogoVirtual}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="row-fields">
                        <div className="form-group">
                            <label htmlFor="nombre">Nombre *</label>
                            <Field
                                name="nombre"
                                component={renderField}
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="marca">Marca</label>
                            <Field
                                name="marca"
                                component={renderField}
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="familia">Familia</label>
                            <Field
                                name="familia"
                                component={renderSearchSelect}
                                loadOptions={getFamilias}
                                valueKey="id"
                                labelKey="nombre"
                                placeholder="Selecciona una familia"
                            />
                        </div>

                        {(tipoProducto === "simple" || tipoProducto === "medida") && (
                        <div className="form-group">
                            <label htmlFor="codigos_barras">Código de barras</label>
                            <FieldArray
                            name="codigos_barras"
                            component={renderCodigosBarras}
                            />
                        </div>
                        )}

                        {(tipoProducto === "simple" || tipoProducto === "medida") && (
                        <div className="form-group">
                            <label htmlFor="descripcion_codigo_barras">Descripción código de barras</label>
                            <Field
                                name="descripcion_codigo_barras"
                                component={renderField}
                                type="text"
                                className="form-control"
                            />
                        </div>
                        )}

                        <div className="form-group">
                            <label htmlFor="descripcion">Descripción *</label>
                            <Field
                                name="descripcion"
                                component={renderTextArea}
                                className="form-control"
                            />
                        </div>

                        {conf_tipo_negocio === "Joyeria" && (
                            <div className="row">
                                <div className="form-group col-12 col-md-6">
                                    <label>Kilataje</label>
                                    <Select
                                        placeholder="Kilataje"
                                        options={kilatajes}
                                        value={kilatajes.find(
                                            option => option.value === kilataje
                                        )}
                                        onChange={(selectedOption) => {
                                            change("kilataje", selectedOption ? selectedOption.value : null);
                                        }}
                                    />
                                </div>

                                <div className="form-group col-12 col-md-6">
                                    <label>Peso (Gramos)</label>
                                    <Field
                                        name="peso"
                                        component={renderField}
                                        type="number"
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
};

const PreciosGeneralesSection = ({readOnlyMode = false,  onNext, onPrevious, canGoNext, canGoPrevious, nombres_precios, conf_porcentaje_precio, cambioPorcentajePrecio, precio2Value, precio3Value, precio4Value, precio5Value, tienda_onlineValue }) => {
    
    return (
        <div className="section-panel">
            <div className="section-header">
                <h4>Precios Generales</h4>
                {!readOnlyMode && (
                    <div className="section-actions">
                        <button 
                            type="button" 
                            className="btn btn-secondary"
                            onClick={() => {
                                console.log('Botón Regresar clickeado - Precios Generales');
                                onPrevious();
                            }}
                            disabled={!canGoPrevious}
                        >
                            Regresar
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-primary"
                            onClick={() => {
                                console.log('Botón Siguiente clickeado - Precios Generales');
                                onNext();
                            }}
                            disabled={!canGoNext}
                        >
                            Siguiente
                        </button>
                    </div>
                )}
            </div>

            <div className={readOnlyMode ? "read-only-wrapper" : ""}>

            <div className="section-header">
                <h5>Precios Venta</h5>
            </div>

            
            <div className="row row-fields">

                <div className="w-100 text-muted small mb-2">
                    Cuentas con varios campos de precio. Solo el primero marcado con (*), es obligatorio. 
                    Los demás son opcionales y se mostrarán en tu punto de venta únicamente si ingresas un valor mayor a cero.
                </div>

                <div className="w-100 text-muted small">
                    Puedes editar los nombres de los precios según tus necesidades, por ejemplo: precio mayorista, 
                    precio minorista o precio especial.
                </div>

                
                <div className="col-sm-12 col-md-2 col-lg-2 form-group">
                    {nombres_precios ? (
                        <label htmlFor="precio">{nombres_precios.nombre_precio} *</label>
                    ) : (
                        <label htmlFor="precio">Precio *</label>
                    )}
                    <Field
                        name="precio"
                        component={renderCurrency}
                        decimalScale={2}
                        type="number"
                        className="form-control"
                        onChange={(event) => {
                            setTimeout(() => {
                                cambioPorcentajePrecio("porcent_precio2", "ProductoCrear");
                                cambioPorcentajePrecio("porcent_precio3", "ProductoCrear");
                                cambioPorcentajePrecio("porcent_precio4", "ProductoCrear");
                                cambioPorcentajePrecio("porcent_precio5", "ProductoCrear");
                            });
                        }}
                    />
                </div>
                <div className="col-sm-12 col-md-2 col-lg-2 form-group">
                    {nombres_precios ? (
                        <label htmlFor="precio2">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            {nombres_precios.nombre_precio2}
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio2Value ? parseFloat(precio2Value) : 0} />)
                                </span>
                            )}
                        </label>
                    ) : (
                        <label htmlFor="precio2">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            Precio 2
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio2Value ? parseFloat(precio2Value) : 0} />)
                                </span>
                            )}
                        </label>
                    )}
                    {conf_porcentaje_precio ? (
                        <Field
                            name="porcent_precio2"
                            component={renderPorcentaje}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("porcent_precio2", "ProductoCrear");
                                });
                            }}
                        />
                    ) : (
                        <Field
                            name="precio2"
                            component={renderCurrency}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("precio2", "ProductoCrear");
                                });
                            }}
                        />
                    )}
                </div>
                <div className="col-sm-12 col-md-2 col-lg-2 form-group">
                    {nombres_precios ? (
                        <label htmlFor="precio3">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            {nombres_precios.nombre_precio3}
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio3Value ? parseFloat(precio3Value) : 0} />)
                                </span>
                            )}
                        </label>
                    ) : (
                        <label htmlFor="precio3">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            Precio 3
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio3Value ? parseFloat(precio3Value) : 0} />)
                                </span>
                            )}
                        </label>
                    )}
                    {conf_porcentaje_precio ? (
                        <Field
                            name="porcent_precio3"
                            component={renderPorcentaje}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("porcent_precio3", "ProductoCrear");
                                });
                            }}
                        />
                    ) : (
                        <Field
                            name="precio3"
                            component={renderCurrency}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("precio3", "ProductoCrear");
                                });
                            }}
                        />
                    )}
                </div>
                <div className="col-sm-12 col-md-2 col-lg-2 form-group">
                    {nombres_precios ? (
                        <label htmlFor="precio4">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            {nombres_precios.nombre_precio4}
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio4Value ? parseFloat(precio4Value) : 0} />)
                                </span>
                            )}
                        </label>
                    ) : (
                        <label htmlFor="precio4">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            Precio 4
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio4Value ? parseFloat(precio4Value) : 0} />)
                                </span>
                            )}
                        </label>
                    )}
                    {conf_porcentaje_precio ? (
                        <Field
                            name="porcent_precio4"
                            component={renderPorcentaje}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("porcent_precio4", "ProductoCrear");
                                });
                            }}
                        />
                    ) : (
                        <Field
                            name="precio4"
                            component={renderCurrency}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("precio4", "ProductoCrear");
                                });
                            }}
                        />
                    )}
                </div>
                <div className="col-sm-12 col-md-2 col-lg-2 form-group">
                    {nombres_precios ? (
                        <label htmlFor="precio5">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            {nombres_precios.nombre_precio5}
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio5Value ? parseFloat(precio5Value) : 0} />)
                                </span>
                            )}
                        </label>
                    ) : (
                        <label htmlFor="precio5">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            Precio 5
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio5Value ? parseFloat(precio5Value) : 0} />)
                                </span>
                            )}
                        </label>
                    )}
                    {conf_porcentaje_precio ? (
                        <Field
                            name="porcent_precio5"
                            component={renderPorcentaje}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("porcent_precio5", "ProductoCrear");
                                });
                            }}
                        />
                    ) : (
                        <Field
                            name="precio5"
                            component={renderCurrency}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("precio5", "ProductoCrear");
                                });
                            }}
                        />
                    )}
                </div>
                {tienda_onlineValue && (
                    <div className="col-sm-12 col-md-2 col-lg-2 form-group">
                        <label htmlFor="precio_online">Precio tienda online *</label>
                        <Field
                            name="precio_online"
                            component={renderCurrency}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                        />
                    </div>
                )}

            </div>
            </div>
        </div>
    );
};


const ManejoProductoSection = ({readOnlyMode = false, categoriaSelect, categorias_expanded, categorias_seleccionados, setCategoriasExpanded, asignarCategoria, categorias, tipoProducto, onNext, onPrevious, canGoNext, canGoPrevious, inventariableValue, tienda_onlineValue, cambioTipoProducto, cambioSeleccionUnidad, seleccion_unidades_medida, unidadDeMedidaValue, tipoProductoValue, fraccionadoValue, unidades_medida, conf_tienda_online }) => {
    console.log("EL TIPO DE PRODUCTO: ", tipoProducto);
    return (
        <div className="section-panel">
            <div className="section-header">
                <h4>Manejo de producto</h4>
                {!readOnlyMode && (
                <div className="section-actions">
                    <button 
                        type="button" 
                        className="btn btn-secondary"
                        onClick={onPrevious}
                        disabled={!canGoPrevious}
                    >
                        Regresar
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-primary"
                        onClick={onNext}
                        disabled={!canGoNext}
                    >
                        Siguiente
                    </button>
                </div>
                )}
            </div>

            <div className={`section-panel ${readOnlyMode ? "read-only-wrapper" : ""}`}>
            {/* 1. Bloque para Producto SIMPLE */}
            {tipoProducto === "simple" && (
                <div className="row">
                    <div className="col-12">

                        {/* SWITCH TIENDA ONLINE */}
                        {conf_tienda_online && tipoProducto !== "fraccionado" && (
                            <div className="form-group">
                                <label htmlFor="tienda_online">Publicar en tienda online</label>
                                <br />
                                <label className="switch">
                                    <Field
                                        name="tienda_online"
                                        component="input"
                                        type="checkbox"
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        )}


                        {!tienda_onlineValue ? (
                            /* Leyenda cuando la tienda está desactivada */
                            <div className="alert alert-warning text-center mt-3">
                                <i className="fa fa-info-circle mr-2"></i>
                                Para gestionar las categorías en línea, activa la opción 
                                <strong> "Publicar en tienda online"</strong> en la sección Datos Generales.
                            </div>
                        ) : (
                            /* Contenido cuando la tienda está activada */
                            conf_tienda_online && (
                                <div className="mt-3">
                                    <div className="form-group">
                                        <label className="text-primary font-weight-bold">
                                            Configuración de Tienda Online
                                        </label>
                                        <p className="text-muted fnt-12">
                                            El producto se ha marcado para venta en línea. A continuación, 
                                            asigne las categorías correspondientes para su visualización en el catálogo.
                                        </p>
                                        <hr />
                                        <label htmlFor="categorias">Seleccione la categoría</label>
                                        <br />
                                        <small className="fnt-12">
                                            Puede seleccionar hasta un máximo de 3 categorías
                                        </small>
                                    </div>
                                    <TreeCategoria
                                        categorias={categorias}
                                        asignarCategoria={asignarCategoria}
                                        setCategoriasExpanded={setCategoriasExpanded}
                                        categorias_seleccionados={categorias_seleccionados}
                                        categorias_expanded={categorias_expanded}
                                    />
                                    {categoriaSelect && (
                                        <div className="invalid-feedback d-block my-2 fnt-10 ml-2">
                                            Campo requerido
                                        </div>
                                    )}
                                </div>
                            )
                        )}
                    </div>
                </div>
            )}

            {tipoProducto === "medida" && (
            <div className="bloque-medida-especifico">

            {Boolean(inventariableValue) && !tienda_onlineValue ? (
                <div className="row">
                    <div className="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-center w-100 ml-3 mt-3">
                            <div className="d-flex flex-column flex-lg-row flex-grow-0">
                                <Field
                                    name="tipo_producto"
                                    component="select"
                                    className="form-control custom-select negro-dark2"
                                    value={tipoProductoValue}
                                    onChange={(e) => {
                                        const valor = e.target.value;
                                        cambioTipoProducto(valor, "crear");
                                        // Activamos la visibilidad de las unidades inmediatamente
                                        cambioSeleccionUnidad(true); 
                                    }}
                                >
                                    <option value="" disabled>Seleccione una opción</option>
                                    <option value="1000">Peso</option>
                                    <option value="2000">Capacidad</option>
                                    <option value="3000">Longitud</option>
                                </Field>
                            </div>
                        </div>
                    </div>
            ) : null}

            

            {tienda_onlineValue && conf_tienda_online && (
                <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label htmlFor="categorias">
                                                            Seleccione la categoría
                                                        </label>
                                                        <br />
                                                        <small className="fnt-12">
                                                            Puede seleccionar hasta un
                                                            máximo de 3 categorías
                                                        </small>
                                                    </div>
                                                    <TreeCategoria
                                                        categorias={categorias}
                                                        asignarCategoria={asignarCategoria}
                                                        setCategoriasExpanded={
                                                            setCategoriasExpanded
                                                        }
                                                        categorias_seleccionados={
                                                            categorias_seleccionados
                                                        }
                                                        categorias_expanded={
                                                            categorias_expanded
                                                        }
                                                    />
                                                    {categoriaSelect && (
                                                        <div className="invalid-feedback d-block my-2 fnt-10 ml-2">
                                                            Campo requerido
                                                        </div>
                                                    )}
                    </div>
                </div>
            )}

                    {/* Aquí iría la lógica para mostrar las unidades de medida según el tipo seleccionado */}
                    {/* Similar al código original pero adaptado a esta sección */}
                    {/* SECCION DE ILUSTRACION DE TIPO DE PRODUCTO */}

                    {tienda_onlineValue && inventariableValue && unidades_medida && unidades_medida.length > 0 && (
                        <Field
                            name="unidad_de_medida"
                            component="input"
                            type="hidden"
                            value={unidadDeMedidaValue || unidades_medida[0].id}
                        />
                    )}
                    
                    <div className="d-flex flex-column">
                        {Boolean(inventariableValue) && !tienda_onlineValue && (
                            
                            <div className="w-100">

                                {/* PRODUCTO PESO */}
                                {tipoProductoValue == "1000" && (
                                    <div className="d-flex flex-column text-center justify-content-center align-items-center">
                                            <div className="w-100">
                                                <h5 className="font-weight-normal negro-dark2 mt-3 fnt-08-rem">
                                                    Esta opción te permite
                                                    comprar y vender en medidas
                                                    de peso, por ejemplo:
                                                    comprar 300 libras y vender
                                                    15.38 libras.
                                                </h5>
                                                <h5 className="font-weight-normal negro-dark2 mb-5 fnt-08-rem">
                                                    Observa la siguiente imagen
                                                </h5>
                                                <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center">
                                                    <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                        <h5 className="negro-dark font-weight-bold">
                                                            Quintal
                                                        </h5>
                                                        <img
                                                            src={
                                                                icons.producto_peso_saco
                                                            }
                                                            alt="producto_simple"
                                                            className="img-fluid"
                                                            style={{
                                                                maxWidth:
                                                                    "150px",
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="linea-vertical rotar-90-deg"></div>
                                                    {/* <img className="rotar-90-deg" src={icons.flecha_derecha_naranja} alt="flecha-derecha" style={{width:"50px", height:"50px"}}/> */}
                                                    <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                        <h5 className="negro-dark font-weight-bold">
                                                            Libra
                                                        </h5>
                                                        <img
                                                            src={
                                                                icons.producto_peso_libra
                                                            }
                                                            alt="producto_simple"
                                                            className="img-fluid"
                                                            style={{
                                                                maxWidth:
                                                                    "150px",
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        
                                            <div className="w-100 mb-4">
                                                <h5 className="font-weight-normal negro-dark2 mt-3 mb-5 fnt-08-rem">
                                                    Elige las medidas que deseas
                                                    comprar y vender tu producto
                                                </h5>
                                                <div className="ml30 mr30 d-flex flex-column flex-lg-row justify-content-center align-items-start align-items-lg-center">
                                                    {unidades_medida.map(
                                                        (unidad, index) => {
                                                            return (
                                                                <div
                                                                    className="radio c-radio c-radio-nofont d-flex"
                                                                    key={index}
                                                                >
                                                                    <label className="negro-dark2 font-weight-normal">
                                                                        <Field
                                                                            name="unidad_de_medida"
                                                                            component="input"
                                                                            type="radio"
                                                                            checked={
                                                                                unidad.id ==
                                                                                unidadDeMedidaValue
                                                                            }
                                                                            value={
                                                                                unidad.id
                                                                            }
                                                                        />
                                                                        <span />
                                                                        {
                                                                            unidad.nombre
                                                                        }
                                                                        &nbsp;&nbsp;
                                                                    </label>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            </div>
                                        
                                    </div>
                                )}

                                {/* PRODUCTO CAPACIDAD */}
                                {tipoProductoValue == "2000" && (
                                    <div className="d-flex flex-column text-center justify-content-center align-items-center">
                                            <div className="w-100">
                                                <h5 className="font-weight-normal negro-dark2 mt-3 fnt-08-rem">
                                                    Esta opción te permite
                                                    comprar y vender en medidas
                                                    de capacidad, por ejemplo:
                                                    comprar 300 litros y vender
                                                    10.35 litros.
                                                </h5>
                                                <h5 className="font-weight-normal negro-dark2 mb-5 fnt-08-rem">
                                                    Observa la siguiente imagen
                                                </h5>
                                                <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center">
                                                    <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                        <h5 className="negro-dark font-weight-bold">
                                                            Galón
                                                        </h5>
                                                        <img
                                                            src={
                                                                icons.producto_capacidad_galon
                                                            }
                                                            alt="producto_simple"
                                                            className="img-fluid"
                                                            style={{
                                                                maxWidth:
                                                                    "150px",
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="linea-vertical rotar-90-deg"></div>
                                                    {/* <img className="rotar-90-deg" src={icons.flecha_derecha_naranja} alt="flecha-derecha" style={{width:"50px", height:"50px"}}/> */}
                                                    <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                        <h5 className="negro-dark font-weight-bold">
                                                            Litro
                                                        </h5>
                                                        <img
                                                            src={
                                                                icons.producto_capacidad_litro
                                                            }
                                                            alt="producto_simple"
                                                            className="img-fluid"
                                                            style={{
                                                                maxWidth:
                                                                    "150px",
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="linea-vertical rotar-90-deg"></div>
                                                    {/* <img className="rotar-90-deg" src={icons.flecha_derecha_naranja} alt="flecha-derecha" style={{width:"50px", height:"50px"}}/> */}
                                                    <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                        <h5 className="negro-dark font-weight-bold">
                                                            Mililitros
                                                        </h5>
                                                        <img
                                                            src={
                                                                icons.producto_capacidad_mililitro
                                                            }
                                                            alt="producto_simple"
                                                            className="img-fluid"
                                                            style={{
                                                                maxWidth:
                                                                    "150px",
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="w-100 mb-4">
                                                <h5 className="font-weight-normal negro-dark2 mt-3 mb-5 fnt-08-rem">
                                                    Elige las medidas que deseas
                                                    comprar y vender tu producto
                                                </h5>
                                                <div className="ml30 mr30 d-flex flex-column flex-lg-row justify-content-center align-items-start align-items-lg-center">
                                                    {unidades_medida.map(
                                                        (unidad, index) => {
                                                            console.log("Unidad CAPACIDAD:", unidad, "Index:", index);
                                                            return (
                                                                <div
                                                                    className="checkbox c-checkbox"
                                                                    key={index}
                                                                >
                                                                    <div
                                                                        className="radio c-radio c-radio-nofont d-flex"
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        <label className="negro-dark2 font-weight-normal">
                                                                            <Field
                                                                                name="unidad_de_medida"
                                                                                component="input"
                                                                                type="radio"
                                                                                checked={
                                                                                    unidad.id ==
                                                                                    unidadDeMedidaValue
                                                                                }
                                                                                value={
                                                                                    unidad.id
                                                                                }
                                                                            />
                                                                            <span />
                                                                            {
                                                                                unidad.nombre
                                                                            }
                                                                            &nbsp;&nbsp;
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            </div>
                                    </div>
                                )}



                                {/* PRODUCTO LONGITUD */}
                                {tipoProductoValue == "3000" && (
                                    <div className="d-flex flex-column text-center justify-content-center align-items-center">
                                            <div className="w-100">
                                                <h5 className="font-weight-normal negro-dark2 mt-3 fnt-08-rem">
                                                    Esta opción te permite
                                                    comprar y vender en medidas
                                                    de longitud, por ejemplo:
                                                    comprar 300 yardas y vender
                                                    10.35 yardas.
                                                </h5>
                                                <h5 className="font-weight-normal negro-dark2 mb-5 fnt-08-rem">
                                                    Observa la siguiente imagen
                                                </h5>
                                                <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center">
                                                    <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                        <h5 className="negro-dark font-weight-bold">
                                                            Metro
                                                        </h5>
                                                        <img
                                                            src={
                                                                icons.producto_longitud_metro
                                                            }
                                                            alt="producto_simple"
                                                            className="img-fluid"
                                                            style={{
                                                                maxWidth:
                                                                    "150px",
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="linea-vertical rotar-90-deg"></div>
                                                    {/* <img className="rotar-90-deg" src={icons.flecha_derecha_naranja} alt="flecha-derecha" style={{width:"50px", height:"50px"}}/> */}
                                                    <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                        <h5 className="negro-dark font-weight-bold">
                                                            Yarda
                                                        </h5>
                                                        <img
                                                            src={
                                                                icons.producto_longitud_yarda
                                                            }
                                                            alt="producto_simple"
                                                            className="img-fluid"
                                                            style={{
                                                                maxWidth:
                                                                    "150px",
                                                            }}
                                                        />
                                                    </div>                                             
                                                </div>
                                            </div>
                                            <div className="w-100 mb-4">
                                                <h5 className="font-weight-normal negro-dark2 mt-3 mb-5 fnt-08-rem">
                                                    Elige las medidas que deseas
                                                    comprar y vender tu producto
                                                </h5>
                                                <div className="ml30 mr30 d-flex flex-column flex-lg-row justify-content-center align-items-start align-items-lg-center">
                                                    {unidades_medida.map(
                                                        (unidad, index) => {
                                                            console.log("Unidad:", unidad, "Index:", index);
                                                            return (
                                                                <div
                                                                    className="checkbox c-checkbox"
                                                                    key={index}
                                                                >
                                                                    <div
                                                                        className="radio c-radio c-radio-nofont d-flex"
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        <label className="negro-dark2 font-weight-normal">
                                                                            <Field
                                                                                name="unidad_de_medida"
                                                                                component="input"
                                                                                type="radio"
                                                                                checked={
                                                                                    unidad.id ==
                                                                                    unidadDeMedidaValue
                                                                                }
                                                                                value={
                                                                                    unidad.id
                                                                                }
                                                                            />
                                                                            <span />
                                                                            {
                                                                                unidad.nombre
                                                                            }
                                                                            &nbsp;&nbsp;
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            </div>
                                    </div>
                                )}
                            </div>
                        )}
                        </div>
                        </div>
                    )}
                    

                    {tipoProducto === "fraccionado" && (
                        <div className="d-flex flex-column text-center justify-content-center align-items-center">
                                                                <h5 className="font-weight-normal negro-dark2 mt-3 fnt-08-rem">
                                                                    Esta opción te permite trabajar por
                                                                    fracciones, por ejemplo: Las
                                                                    farmacias que venden sus productos
                                                                    individuales.
                                                                </h5>
                                                                <h5 className="font-weight-normal negro-dark2 mb-5 fnt-08-rem">
                                                                    Observa la siguiente imagen
                                                                </h5>
                                                                <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center">
                                                                    <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                                        <h5 className="negro-dark font-weight-bold">
                                                                            Fardo
                                                                        </h5>
                                                                        <img
                                                                            src={icons.fraccion_fardo}
                                                                            alt="producto_simple"
                                                                            className="img-fluid"
                                                                            style={{
                                                                                maxWidth: "150px",
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <img
                                                                        className="rotar-90-deg"
                                                                        src={icons.flecha_derecha}
                                                                        alt="flecha-derecha"
                                                                        style={{
                                                                            width: "50px",
                                                                            height: "50px",
                                                                        }}
                                                                    />
                                                                    <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                                        <h5 className="negro-dark font-weight-bold">
                                                                            Caja
                                                                        </h5>
                                                                        <img
                                                                            src={icons.fraccion_caja}
                                                                            alt="producto_simple"
                                                                            className="img-fluid"
                                                                            style={{
                                                                                maxWidth: "150px",
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <img
                                                                        className="rotar-90-deg"
                                                                        src={icons.flecha_derecha}
                                                                        alt="flecha-derecha"
                                                                        style={{
                                                                            width: "50px",
                                                                            height: "50px",
                                                                        }}
                                                                    />
                                                                    <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                                        <h5 className="negro-dark font-weight-bold">
                                                                            Blister
                                                                        </h5>
                                                                        <img
                                                                            src={icons.fraccion_blister}
                                                                            alt="producto_simple"
                                                                            className="img-fluid"
                                                                            style={{
                                                                                maxWidth: "150px",
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <img
                                                                        className="rotar-90-deg"
                                                                        src={icons.flecha_derecha}
                                                                        alt="flecha-derecha"
                                                                        style={{
                                                                            width: "50px",
                                                                            height: "50px",
                                                                        }}
                                                                    />
                                                                    <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                                        <h5 className="negro-dark font-weight-bold">
                                                                            Pastillas
                                                                        </h5>
                                                                        <img
                                                                            src={
                                                                                icons.fraccion_pastilla
                                                                            }
                                                                            alt="producto_simple"
                                                                            className="img-fluid"
                                                                            style={{
                                                                                maxWidth: "150px",
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                        
                                                            </div>

                    )}

                    {/* SECCION DE CRUD DE FRACCIONES */}
                    {Boolean(fraccionadoValue) &&
                    Boolean(inventariableValue) ? (
                        <div className="row row-fields mt-3">
                            <FraccionesComponent />
                        </div>
                    ) : null}
            </div>
        </div>
    );
};


const ResumenSection = ({ 
    onPrevious, 
    onNext, 
    canGoPrevious, 
    tipoProducto, // El key: 'simple', 'medida' o 'fraccionado'
    unidades_medida,
    sucursales,

    hasPreciosSucursal, 
    sucursal, 
    changeSucursal, 
    sucursal_activo, 
    nombres_precios, 
    changeSucursalActivo, 
    conf_porcentaje_precio, 
    cambioPorcentajePrecio, 
    precios_sucursalValue,
    goToSection,
    invalid,
    handleSubmit,
    ...props 
}) => {
    // Obtenemos el listado de secciones que corresponden a este tipo
    // Filtramos 'resumen' para no renderizarnos a nosotros mismos infinitamente
    var seccionesAMostrar = SECTIONS_BY_TIPO[tipoProducto] || [];


    const handleFinish = () => {
        if (invalid) {

            handleSubmit(() => {})(); // fuerza validación visual

            Swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: "Hay campos obligatorios sin completar",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            });

            return;
        }

        onNext();
    };

    
    return (
        <div className="section-panel resumen-dinamico">
            <div className="section-header border-bottom mb-4">
                <div>
                    <h4>Resumen de Configuración</h4>
                    <p className="text-muted fnt-12">Revisa cada sección antes de finalizar el registro.</p>
                </div>
            </div>

            <div className="resumen-content">
                {seccionesAMostrar.map(function(sectionId) {
                    // No renderizamos la sección de resumen dentro del resumen
                    if (sectionId === "resumen") return null;

                    return (
                        <div key={sectionId} className="resumen-block mb-5 pb-4 border-bottom">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <div>
                                    <span className="badge badge-warning mr-2">Sección</span>
                                </div>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => goToSection(sectionId)}
                                >
                                    <i className="fa fa-pencil mr-1"></i>
                                    Editar
                                </button>
                            </div>
                            
                            {/* Renderizado Condicional de los componentes originales */}
                            {sectionId === "datos-generales" && (
                                <DatosGeneralesSection {...props} readOnlyMode onNext={null} onPrevious={null} />
                            )}
                            {sectionId === "inventario-inicial" && (
                                <InventarioInicialSection {...props} readOnlyMode sucursales={sucursales} onNext={null} onPrevious={null} />
                            )}
                            {sectionId === "precios-generales" && (
                                <PreciosGeneralesSection {...props} readOnlyMode onNext={null} onPrevious={null} />
                            )}
                            {sectionId === "precio-sucursal" && (
                                <PrecioSucursalSection
                                    {...props}
                                    hasPreciosSucursal={hasPreciosSucursal}
                                    sucursales={sucursales}
                                    sucursal={sucursal}
                                    changeSucursal={changeSucursal}
                                    sucursal_activo={sucursal_activo}
                                    nombres_precios={nombres_precios}
                                    changeSucursalActivo={changeSucursalActivo}
                                    conf_porcentaje_precio={conf_porcentaje_precio}
                                    cambioPorcentajePrecio={cambioPorcentajePrecio}
                                    precios_sucursalValue={precios_sucursalValue}
                                    onNext={null}
                                    onPrevious={null}
                                    readOnlyMode
                                />
                            )}
                            {sectionId === "propiedades-producto" && (
                                <PropiedadesProductoSection {...props} readOnlyMode onNext={null} onPrevious={null} />
                            )}
                            {sectionId === "manejo-producto" && (
                                <ManejoProductoSection {...props} readOnlyMode tipoProducto={tipoProducto} unidades_medida={unidades_medida} onNext={null} onPrevious={null} />
                            )}
                        </div>
                    );
                })}
            </div>

            <div className="alert alert-warning text-center">
                <strong>¿Todo correcto?</strong> Si necesitas cambiar algo, puedes usar el botón <strong>"Regresar"</strong>, el menú lateral o el botón <strong>"Editar"</strong> de cada sección en el resumen.
            </div>

            <div className="section-actions justify-content-between">
                <button 
                    type="button" 
                    className="btn btn-secondary"
                    onClick={onPrevious}
                    disabled={!canGoPrevious}
                >
                    Regresar
                </button>

                <button 
                    type="button" 
                    className="btn btn-primary"
                    onClick={handleFinish}
                >
                    <i className="fa fa-check-circle mr-2"></i>
                    Finalizar y Guardar
                </button>
            </div>
        </div>
    );
};




let ProductoForm = reduxForm({
    form: "ProductoCrear",
    validate,
})(Form);

const selector = formValueSelector("ProductoCrear");

ProductoForm = connect((state) => {
    const store = state.producto;
    const form = state.form.ProductoCrear;
    let categoriaSelect = false;
    const tienda_onlineValue = selector(state, "tienda_online");
    if (form && tienda_onlineValue) {
        const { submitFailed, submitSucceeded } = form;
        categoriaSelect = store.categorias_seleccionados.length <= 0 && (submitFailed || submitSucceeded);
    }

    const tipoProductoValue = selector(state, "tipo_producto");
    const fraccionadoValue = parseInt(tipoProductoValue) == 100 ? true : false;
    const inventariableValue = selector(state, "inventariable");
    const alertaValue = selector(state, "alertar");
    const unidadDeMedidaValue = selector(state, "unidad_de_medida");
    const kilataje = selector(state, "kilataje");
    const familiaValue = selector(state, "familia");
    const precio2Value = selector(state, "precio2");
    const precio3Value = selector(state, "precio3");
    const precio4Value = selector(state, "precio4");
    const precio5Value = selector(state, "precio5");
    const precios_sucursalValue = selector(state, "precios_sucursal");
    
    return {
        tipoProductoValue,
        fraccionadoValue,
        inventariableValue,
        alertaValue,
        unidadDeMedidaValue,
        tienda_onlineValue,
        categoriaSelect,
        precio2Value,
        precio3Value,
        precio4Value,
        precio5Value,
        precios_sucursalValue,
        kilataje,
        familiaValue,
        initialValues: {
            ...state.producto.producto,
            vendible: true,
            precios_sucursal: [],
            precio: 0,
        },
    };
})(ProductoForm);

export default ProductoForm; 